import Vue from 'vue';
import App from './App.vue';
import { router, resetRouter } from './router';
import store from './store';
import importUI from './import-ui.js'; // element-ui
import computeTableHeight from './utils/computeTableHeight.js'; // 表格高度计算
import { Message } from 'element-ui';
import api from './api';
import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import '@/assets/styles/vxe.scss';
import { getItem } from './utils/cookie.js';
import dayjs from 'dayjs';
import reportEvent from '@/utils/reportEvent.js'

Vue.use(importUI);
Vue.use(VXETable);
Vue.config.productionTip = false;
Vue.prototype.$http = api;
// 全局定义图片尺寸大小
Vue.prototype.$ImgQuality20 = '?x-oss-process=image/format,webp/resize,w_200/quality,Q_70';
Vue.prototype.$ImgQuality30 = '?x-oss-process=image/format,webp/resize,w_200/quality,Q_70';
Vue.prototype.$ImgQuality50 = '?x-oss-process=image/format,webp/resize,w_500/quality,Q_70';
Vue.prototype.$ImgPreviewQuality = '?x-oss-process=image/format,webp/resize,w_1000/quality,Q_70';
Vue.prototype.$textareaQuality = '?x-oss-process=image/format,webp/quality,Q_60';
Vue.prototype.$computeTableHeight = computeTableHeight;
// 全局指令操作用户按钮权限
Vue.directive('hasPermission', {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_hasPermission(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
});
Vue.prototype.$_hasPermission = function(value) {
  return store.getters.userSelf.buttonPermissions.includes(value);
};
// 时间戳转换
Vue.filter('dateFilter', function (value) {
  if (!value) return '';
  value = Number(value);
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
})

// 动态添加路由
function addRoutes(menus) {
  const base = [
    {
      path: '/',
      component: () => import('@/components/HomePage.vue'),
    },
  ];
  let children = menus
    .filter(item => item.href)
    .map(({ href, name }) => {
      return {
        path: href,
        name: href,
        meta: {
          title: name,
        },
        component: () => import(`@/views/${href}`),
      };
    });
  // 清空路由缓存
  resetRouter();
  router.addRoute({
    ...base[0],
    children,
  });
}

router.beforeEach(async (to, from, next) => {
  // 路由切换取消页面请求
  store.commit('cancelRequest/clearToken');
  // 获取token
  const hasToken = ((getItem() || localStorage.getItem('sessionId')) || '').length > 0;
  if (hasToken) {
    if (to.path === '/login') {
      next('/');
    } else {
      // 获取路由权限调用微服务的api
      const needAddRoute = (store.getters.userSelf.menus || []).length === 0;
      if (needAddRoute) {
        // 获取个人信息
        const [err, data] = await store
          .dispatch('user/userSelf')
          .then(data => [null, data])
          .catch(err => [err]);
        // 登录成功但是没有分配权限
        if (err && err.msg) {
          Message.error(err.msg);
          store.dispatch('user/clearLoaclstorage');
          store.dispatch('user/clearUserSelf');
          next('/login');
          return;
        }
        if (data && data.sessionId && data.sessionId !== '') {
          sessionStorage.setItem('sessionValid', 1);
        }
        // 获取所有字典数据
        await Promise.all([
          store.dispatch('publicData/getAllDictList'),
          store.dispatch('user/userSupplier'),
          store.dispatch('user/updateLoginDate'),
        ]).catch(err => console.log(err));
        // 动态路由
        addRoutes(data.menus);
        next({
          ...to,
          replace: true,
        });
      } else {
        next();
      }
    }
  } else {
    if (to.path === '/login') {
      next();
    } else {
      next('/login');
    }
  }
});
router.afterEach((to) => {
  // 页面跳转埋点处理
  const basicInfo = {
    event: 'PageView',
    path: location.href,
    name: to.meta.title
  }
  reportEvent(basicInfo);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
